import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '../Base/AntGrid';
import { fetchServer } from '../Base/modelManager';
import { excelExport } from '../Base/ExportExcelAction';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ContactsEditor from './ContactsEditor';
import { message } from 'antd';


class Contacts extends React.Component {
    constructor(props) {
        super(props)

        const actions = [
            {
                id: 'reload',
                icon: <img src="/assets/images/icons/arrow-counterclockwise.svg" alt="Bootstrap" width="16" height="16" />,
                tooltip: 'Recharger',
                onExecute: () => {
                    this.handleFetch()
                }
            },
            excelExport(this.props.apiUrl + '/Services/exportContacts', 'Contacts.xlsx', this.getFilterProcessed, () => '', this.getToken)
        ]


        this.state = {
            data: [],
            columns: [],
            loading: false,
            keyField: '',
            queryColumns: [],
            height: 0,
            quickFilterString: '',
            actions: actions,
            render: true,
            selectedRows: [],
            modal: {
                isOpen: false,
                view: null,
                record: null,
                factureID: null,
                clientid: null
            },
            filters: {
                statusCarte: [500]
            },
            pagination: {
                current: 1,
                total: 0,
                pageSize: 10,
            }


        }
    }

    getToken = () => {
        return this.props.JWTToken
    }

    getFilterProcessed = () => {
        const { filter } = this.state

        return this.processFilter(filter)
    }

    componentDidMount() {
        this.handleFetch()
    }

    componentDidUpdate(prevProp) {
        if (prevProp.currentClient !== this.props.currentClient)
            this.handleFetch()
    }

    closeModal = () => {
        this.setState({
            modal: {
                isOpen: false,
                view: null,
                record: null
            }
        })
        this.handleFetch()
    }

    getModalComponent = () => {
        const { modal } = this.state

        if (modal.isOpen) {
            return (
                <Modal show={modal.isOpen} >
                    <ContactsEditor record={modal.record} onClose={() => this.closeModal()} />
                </Modal>
            )
        }
    }



    columns = () => {
        const cols = []



        cols.push(

            {
                title: 'Nom',
                render:(text,record) => record.nom,
                width: '150px'
            },
            {
                title: 'Prenom',
                render:(text,record) => record.prenom,
                width: '150px'
            },
            {
                title: 'Fonction',
                render:(text,record) => record.fonction,
                width: '100px'
            },
            {
                title: 'Telephone',
                render:(text,record) => record.telephone,
                width: '120px'
            },
            {
                title: 'Mobile',
                render:(text,record) => record.mobile,
                width: '120px'
            },
            {
                title: 'Email',
                render:(text,record) => record.email,
                width: '250px'
            },
            {
                title: 'Rec. Fac.',
                render:(text,record) => <Form.Check checked={record.emailfact} />,
                width: '50px',
                wrap:true
            },
            {
                title: 'Esp. Cli.',
                render:(text,record) => <Form.Check checked={record.espaceClient} />,
                width: '50px',
                wrap:true
            },

            {
                title: 'Alert. Plaf.',
                render:(text,record) => <Form.Check checked={record.alerteplafond} />,
                width: '50px',
                wrap:true
            },
            {
                title: 'Plaf.',
                render:(text,record) => <Form.Check checked={record.plafond!==undefined?record.plafond!==undefined:false} />,
                width: '50px',
                wrap:true
            },
            {
                title: 'Gest.',
                render:(text,record) => <Form.Check checked={record.gestion!==undefined?record.gestion!==undefined:false} />,
                width: '50px',
                wrap:true
            },
            {
                title: 'Com.',
                render:(text,record) => <Form.Check checked={record.commande!==undefined?record.commande!==undefined:false} />,
                width: '50px',
                wrap:true
            }
        )

        if(this.props.currentClient.gestion)
        cols.push({
            title: 'Actions',
            key: 'operation',
            dataIndex: 'operation',
            fixed: 'right',
            width: '50px',
            render:(text,record) => this.actionRenderer(record),
        })


        return cols

    }

    customStyles = {

        headCells: {
            style: {
                paddingLeft: '2px', // override the cell padding for head cells
                paddingRight: '2px',
            },
        },
        cells: {
            style: {
                paddingLeft: '2px', // override the cell padding for data cells
                paddingRight: '2px',
            },
        },
    };



    processFilter = (filter) => {


        let filterStr = ''

        if (filter !== undefined && filter !== null) {
            const filtersValue = Object.keys(filter);
            if (filtersValue.length > 0) {
                filtersValue.forEach(key => {
                    if (key === 'numero' && filter[key] !== null) {
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + 'contains(numero,\'' + filter[key] + '\')'
                    }
                    if (key === 'client' && filter[key] !== null) {
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(contains(client/numero,\'' + filter[key] + '\') or contains(client/nom,\'' + filter[key] + '\'))'
                    }
                    if (key === 'actif')
                        if (filter[key] !== null && filter[key][0] !== -1) {
                            if (filterStr !== '') filterStr = filterStr + ' and '
                            filterStr = filterStr + ' status/isActif eq ' + (filter[key][0] === 1 ? 'true' : 'false')
                        }
                    if (key === 'status' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'status/uid eq ' + value
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }

                    if (key === 'fournisseur' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'fournisseur/code eq \'' + value + '\''
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }
                    if (key === 'typecarte' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'typeCarte/code eq \'' + value + '\''
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }
                })
            }


        }


        if (this.props.client !== undefined) {
            if (filterStr !== '') filterStr = filterStr + ' and '

            filterStr = filterStr + ' client/uid eq ' + this.props.client.uid
        }





        if (filterStr !== '')
            filterStr = '&$filter=' + filterStr




        return filterStr
    }

    onError = (error) => {
        message.error(error)
    }

    openModal = (action, data) => {
        this.setState(
            {
                modal: {
                    isOpen: true,
                    view: action,
                    record: data,
                }
            }
        )
    }

    actionRenderer = (record) => {


        const actions = []
        actions.push(
            {
                id: 'edit',
                icon: <img className="gridHeaderImage" alt='' src="/assets/images/icons/pencil-square.svg" style={{ 'marginRight': '4px' }} />,
                tooltip: 'Modifier',
                onExecute: (event) => {
                    this.openModal('Edit', record)
                }
            })



        return (
            <span>
                {
                    actions.map((action) => {
                        const renderTooltip = (props) =>
                            <Tooltip id={props.id}>
                                {props.tooltip}
                            </Tooltip>

                        return (
                            <OverlayTrigger
                                key={action.id}
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip(action)}
                            >

                                <Button bsPrefix="gridButton" onClick={(event) => { action.onExecute(event) }}> {action.icon}</Button>

                            </OverlayTrigger>

                        )
                    })
                }
            </span>

        )
    }

    handleFetch = (pagination, filters, sorter) => {



        if (this.state.loading === false) {
            this.setState({ loading: true })

            if (pagination === undefined)
                pagination = this.state.pagination


            if (filters === undefined)
                filters = this.state.filters

            if (sorter === undefined)
                sorter = this.state.sorter

            //const filter = this.processFilter(filters)

            // filter.page = page;
            // filter.pageSize = this.state.pageSize

            const request = {
                endPoint: this.props.apiUrl + '/Services/Clients/Contacts', //'/contacts?$top=' + pagination.pageSize + '&$skip=' + pagination.pageSize * (pagination.page - 1) + '&$inlinecount=allpages' + filter,
                method: 'GET',
                token: this.props.JWTToken
            }

            fetchServer(request,
                (json) => {
                    this.setState(({
                        loading: false,
                        data: json,
                        pagination: {
                            total: json.length,
                            current: pagination.current,
                            pageSize: json.length
                        },
                        render: true,
                        filters: filters

                    }))
                },
                (error) => this.onError(error.error))

        }
    }

    render() {

        return (
            <>
                {this.getModalComponent()}
                <Grid
                    data={this.state.data}
                    columns={this.columns()}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    keyField='id'
                    handleFetch={this.handleFetch}
                    actions={this.state.actions}
                    customStyles={this.customStyles}
                    title='- MES CONTACTS -'
                />
            </>
        )


    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

Contacts.propTypes = {
    dispatch: PropTypes.func,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    apiUrl: PropTypes.string,
    JWTToken: PropTypes.string
};

export default connect(mapStateToProps)(Contacts);
